import React from 'react';

import SalonFlag from 'components/core/SalonFlag.component';
import FormError from 'components/form/FormError.component';
import Space from 'components/generic/Space.component';
import S from 'constants/string.const';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('ErrorBoundary');

// SEE: https://reactjs.org/docs/error-boundaries.html
class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return { error };
  }

  constructor() {
    super();
    this.state = {};
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error, errorInfo) {
    L.warn('componentDidCatch()', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = asObject(this.state);
    const { children, tag, strat } = asObject(this.props);
    const { componentStack } = asObject(errorInfo);

    // happy scenario, no errors, just return the children
    if (!error) return children;

    // strategy: print only to console and let it be
    if (strat === 'console') {
      L.warn('()', tag, 'error:', error);
      L.warn('()', tag, 'errorInfo:', errorInfo);
      return children;
    }

    // strategy: print user facing error looking text in the UI
    // TODO: make it possible to render any custom fallback UI
    return (
      <span data-bem="ErrorBoundary" data-tag={tag}>
        <Space>
          {tag}
          {S.colon}
        </Space>
        <Space>
          <FormError value={error} />
        </Space>
        <SalonFlag.IfDevelopment>
          <Space>
            <FormError value={componentStack} />
          </Space>
        </SalonFlag.IfDevelopment>
      </span>
    );
  }
}

// noinspection JSUnusedGlobalSymbols
export default ErrorBoundary;
